"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APPOINTMENT_EXPIRY_RESPONSE_EXAMPLE = exports.CANCEL_APPOINTMENT_RESPONSE_EXAMPLE = void 0;
/**
 * Response DTOs for the 4 Scheduling endpoints — reuses `AppointmentDto`
 * (`appointment-common.response.ts`), never a second declaration of
 * the same shape.
 */
const appointment_common_response_1 = require("./appointment-common.response");
exports.CANCEL_APPOINTMENT_RESPONSE_EXAMPLE = {
    appointment: { ...appointment_common_response_1.APPOINTMENT_RESPONSE_EXAMPLE, status: 'CANCELLED' },
    slotReleased: false,
    remindersCancelled: 0,
};
exports.APPOINTMENT_EXPIRY_RESPONSE_EXAMPLE = {
    expired: [{ ...appointment_common_response_1.APPOINTMENT_RESPONSE_EXAMPLE, status: 'CANCELLED' }],
};
//# sourceMappingURL=scheduling.response.js.map